export const s4 = '4px';
export const s8 = '8px';
export const s16 = '16px';
export const s24 = '24px';
export const s32 = '32px';
export const s64 = '64px';

export const spacing = {
  s4,
  s8,
  s16,
  s24,
  s32,
  s64,
};
